import { Schema as S } from "effect";

export const FindPatientRequestSchema = S.Struct({
  _id: S.String,
});

export type FindPatientRequest = S.Schema.Type<typeof FindPatientRequestSchema>;
